// Detects embedded / in-app browsers (Instagram, Facebook, X, LinkedIn, etc.)
// where Google OAuth is blocked with "disallowed_useragent".
export const isInAppBrowser = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';
  const markers = [
    'FBAN', 'FBAV', 'FB_IAB', 'Instagram', 'LinkedInApp', 'Twitter',
    'Line/', 'Snapchat', 'musical_ly', 'Bytedance', 'TikTok',
    'MicroMessenger', 'Pinterest', 'GSA/',
  ];
  const hit = markers.some((m) => ua.indexOf(m) !== -1);
  const androidWebview = /;\s*wv\)/.test(ua) || /\bwv\b/.test(ua);
  return hit || androidWebview;
};
